import moment from 'moment'

export const maskEmail = (email) => {
  const [name, domain] = email.split('@')
  const visible = name.slice(0, 4)
  const maskedPart = '*'.repeat(Math.max(name.length - 4, 0))
  return visible + maskedPart + '@' + domain
}

export const getFormattedDate = (dateValue) => {
  const date = new Date(`${dateValue}T00:00:00`)
  const formattedDate = moment(date).format('MMMM DD, YYYY')
  return formattedDate
}
